import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import Icon from 'components/UI/Icon';
import { HOME_PAGE } from '@/constants/pagesUrl';
import * as styles from './footerNavigation.module.scss';

const FooterNavigation = ({ navigation }) => {
  return (
    <div className={classnames(styles.footerNavigation)}>
      <div
        className={classnames(
          styles.logoWrap,
          'cr-footer-first-flex cr-footer-block-right-gap'
        )}
      >
        <Link
          to={HOME_PAGE}
          className={classnames(styles.logo, 'cr-bounce-scale')}
        >
          <Icon name={'cirrus-logo-white'} />
        </Link>
      </div>
      <ul className={classnames(styles.list)}>
        {navigation.map((item) => {
          return (
            <li key={item.title} className={classnames(styles.listItem)}>
              <Link to={item.url} className={classnames(styles.listLink)}>
                <span className={'cr-subheader-3 cr-txt-strong'}>
                  {item.title}
                </span>
              </Link>

              <ul>
                {item.sub_navigation.map((subItem) => {
                  return (
                    <li
                      key={subItem.url}
                      className={classnames(styles.sublistItem)}
                    >
                      <Link
                        to={subItem.url}
                        className={classnames(styles.sublistLink)}
                      >
                        <span className={'cr-subheader-3'}>
                          {subItem.title}
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FooterNavigation;
